<template>
	<div class="text-left whatsNewContainer1">
		<h1 class="text-center">What's New With ASA24  </h1>
		<br>
		<div class="blogPostCard">
			<div class="blogPost">
				<div class="blogPostDate">04/05/2022</div>
				<div class="blogPostTitle">Welcome to the new ASA24 researcher site!</div>
				<div class="blogPostMessage1">
					Its features include:
					<br>
					<br>
					<p>
						<ul>
							<li>Modern look and feel</li>
							<li>Improved home page and navigation</li>
							<li>Easier access to help for study set up and respondent account creation</li>
							<li>New options for downloading analysis files</li>
							<li>Improved tracking for scheduled studies</li>
							<li>
								New Respondent Nutrition Report (RNR) capabilities:
								<ul>
									<li>For recalls, researchers can decide whether or not the RNR will be available to participants after a recall</li>
									<li>Researchers can create RNRs for respondents who refused or skipped creating one during a recall or record</li>
									<li>Researchers can choose which language to view the RNR in the researcher site</li>
								</ul>
							</li>
						</ul>
					</p>
					<br>
					<p>
						To assist researchers, a Quick User Guide has been developed providing guidance on creating and managing studies. The Quick User Guide can be found on the login page and in the “Help & Resources” tab. The guide is an abbreviated version of the previous Researcher Instructions. Some of the information previously found in the Research Instructions can also be found on the “Help & Resources” tab in the new researcher website.
					</p>
					<br>
					<p>
						Our team has extensively tested the new researcher website; however, if you find any issues, please use the report a bug form to notify the ASA24 Support Team.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WhatsNewHard'
}
</script>

<style>
</style>
